export type ReportingPipeline = 'legacyGlobal' | 'isolatedPrivateV1';

export const createPageSessionReportingPipelineSelector = (
	isIsolatedReporterEnabled: () => boolean,
): {
	get: () => ReportingPipeline;
	resetForTests: () => void;
} => {
	let selected: ReportingPipeline | undefined;

	return {
		get: () => {
			selected ??= isIsolatedReporterEnabled() ? 'isolatedPrivateV1' : 'legacyGlobal';
			return selected;
		},
		resetForTests: () => {
			selected = undefined;
		},
	};
};
